export default {
  name: 'IconList'
};